import { cardItems } from "@/mocks/homeData";

export default function CardsSection() {
  return (
    <section id="cards" className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
            精选剧集
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            高分好剧一网打尽，从经典到热门应有尽有
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {cardItems.map((item) => (
            <a
              key={item.id}
              href="#media"
              className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-300/50 transition-all cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                  loading="lazy"
                />
                <span className="absolute top-2 right-2 text-[10px] font-medium text-background-50 bg-accent-500/90 px-2 py-0.5 rounded whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-semibold text-foreground-950 whitespace-nowrap">
                    {item.title}
                  </h3>
                  <span className="text-[11px] text-foreground-500 bg-background-100 px-1.5 py-0.5 rounded whitespace-nowrap">
                    {item.genre}
                  </span>
                </div>
                <p className="mt-2 text-xs text-foreground-600 line-clamp-2 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}